export const NO_RESULTS_TEXT =
  "The location you entered does not match a location currently on sale.";
export const CLEAR_SEARCH_TEXT = "Clear";
export const AUTOCOMPLETE_HEADING_TEXT = "Destinations on sale by continent";
export const AUTOCOMPLETE_INPUT_LABEL = (offerCount: number) =>
  `Find a destination on sale (${offerCount})`;
